import { COLLECTION_NAME, QUESTION_SCORE } from "./constants";
import { db } from "./firebase-config";
import "firebase/database";
import { Questions, Team } from "./types";
import { getDurationBetweenDates } from ".";

export const addTeam = async (name: string) => {
  const teamId = db.collection(COLLECTION_NAME).doc().id;
  await db.collection(COLLECTION_NAME).doc(teamId).set({
    name,
    create_at: new Date().toISOString(),
    lastAnswer_at: new Date().toISOString(),
    score: 0,
    answersScores: [],
    falseAnswers: [],
  });
  return teamId;
};

export const updateLastAnswer = async (teamId: string) => {
  db.collection(COLLECTION_NAME)
    .doc(teamId)
    .update({ lastAnswer_at: new Date().toISOString() });
};

export const updateTeamScore = async (
  team: Team,
  questionId: string,
  val: number
) => {
  let answersScores = [...team.answersScores];
  let falseAnswers = [...team.falseAnswers];
  if (val > 0) {
    answersScores.push(questionId);
    falseAnswers = falseAnswers.filter((id) => id !== questionId);
  } else {
    falseAnswers.push(questionId);
    answersScores = answersScores.filter((id) => id !== questionId);
  }
  await db.collection(COLLECTION_NAME).doc(team.id).update({
    answersScores,
    falseAnswers,
  });
};

export const getTeamAnswerDuration = async (teamId: string) => {
  const teamRef = db.collection(COLLECTION_NAME).doc(teamId).get();
  const teamData = (await teamRef).data() as
    | { create_at: string; lastAnswer_at: string }
    | undefined;

  if (!teamData) return {};
  return getDurationBetweenDates(teamData?.create_at, teamData?.lastAnswer_at);
};

export const getQuestions = async (): Promise<Questions[]> => {
  const questionsDocs = (await db.collection("Questions").get()).docs;
  const questions = questionsDocs.map((doc) => ({
    id: doc.id,
    value: doc.data().value,
    isAnswer: false,
  }));
  return questions;
};

export const getAllTeams = async (): Promise<Team[]> => {
  const teamsDocs = (await db.collection(COLLECTION_NAME).get()).docs;
  const teams = teamsDocs.map((doc) => {
    const data = doc.data();
    return {
      id: doc.id,
      name: data.name,
      create_at: data.create_at,
      lastAnswer_at: data.lastAnswer_at,
      answersScores: data.answersScores,
      falseAnswers: data.falseAnswers,
      score: data.answersScores.length * QUESTION_SCORE,
    };
  });
  return teams;
};
